module.exports = __webpack_public_path__ + "img/SFA Event5.71f988f5.jpeg";